import { useMemo } from "react";
import useFetch from "./useFetch";

export default function useDropdown(endpoint) {
  const { data = [] } = useFetch(endpoint);
  return useMemo(
    () => data.map((d) => ({ label: d.displayed, value: String(d.stored) })),
    [data]
  );
}
